import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { Presupartienc } from "../coninterfaces/conencpresuparti";
import { Presupartidet } from '../coninterfaces/condetpresuparti';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { isNullOrUndefined } from 'util';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { InvbusquedaService } from '../../inv/invservicios/invbusqueda.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { ConpartidapresuService } from "../conservicios/conpartidapresu.service";
import * as XLSX from 'xlsx';//CDPJ
import { UploadfilesService } from '../../advantage/advantageservices/uploadfiles.service';

@Component({
  selector: 'app-conpartidapresu',
  templateUrl: './conpartidapresu.component.html',
  styleUrls: ['../../advantage/styles/saciwebmae.css']
})
export class ConpartidapresuComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  @ViewChild('inputFile') inputfile: ElementRef

  btnNuevo: boolean;
  btnGuardar: boolean;
  btnBorrar: boolean;
  btnRegresar: boolean;
  indicador: any;
  index
  boolnuevo: boolean;
  //agrgrid
  rowSelection = 'multiple';
  public frameworkComponents;
  defaultColDefPartiPresu;
  rowStyle;
  detpartipresuelect: Presupartidet;
  permisoParpre: SegMaePermiso;
  datosJson: any = [];
  spin = false;
  //busqueda
  opcion: string;
  types: SelectItem[];
  arregloCons: any[];
  displayDialogBusquedaFast: boolean;
  displayDialogSelectPCC: boolean;
  busquedacampos: string[];
  tabla: string;
  where: string;
  lblestado: string = '';
  displayDialogAutorizacion: boolean;
  claveAuth: string;
  actestado: string;
  displayDialogRazon: boolean;
  mensajeestado: string
  razonaut = '';
  columnDefspartipresu = [
    {
      headerName: 'Número', field: 'DETPARPRE_NUMERO', cellEditor: 'cellPrueba', width: 150, editable: (params) => {
        return true;
      }, pinned: 'left',
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 30
        }
      }

    },
    {
      headerName: 'Nombre', field: 'DETPARPRE_NOMBRE', cellEditor: 'cellPrueba', width: 180, editable: (params) => {
        return true;
      }, pinned: 'left',
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          clave: false,
          tamanocelda: 50
        }
      }
    },
    {
      headerName: 'Enero', field: 'DETPARPRE_01', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, 
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Febrero', field: 'DETPARPRE_02', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Marzo', field: 'DETPARPRE_03', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Abril', field: 'DETPARPRE_04', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Mayo', field: 'DETPARPRE_05', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Junio', field: 'DETPARPRE_06', cellEditor: 'cellPrueba', width: 100, eeditable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Julio', field: 'DETPARPRE_07', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Agosto', field: 'DETPARPRE_08', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Septiembre', field: 'DETPARPRE_09', cellEditor: 'cellPrueba', width: 120, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Octubre', field: 'DETPARPRE_10', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Noviembre', field: 'DETPARPRE_11', cellEditor: 'cellPrueba', width: 120, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Diciembre', field: 'DETPARPRE_12', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return true;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    {
      headerName: 'Total', field: 'DETPARPRE_TOTAL', cellEditor: 'cellPrueba', width: 100, editable: (params) => {
        return false;
      }, cellStyle: { textAlign: 'right' },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    }

  ]

  etiquetasaudi: any[];

  constructor(
    private init: NuevoComponentService, private messageService: MessageService, private confirmationService: ConfirmationService,
    public conpartidapresuService: ConpartidapresuService, private permisosService: PermisosService, private auditoriagral: AuditoriagralService,
    private busquedaSer: InvbusquedaService, public uploadFileService: UploadfilesService,
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };
    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefPartiPresu = {
      editable: true,
      width: 130,
      objeto: 'partipresu'
    };

  }
  async ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.btnNuevo = false;
    this.btnGuardar = true;
    this.btnBorrar = false;
    this.btnRegresar = true;
    this.index = 0;
    this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador] = {};
    this.conpartidapresuService.detpartipresupuestoarray = [];
    this.detpartipresuelect = {}
    this.etiquetasaudi = [
      { codigo: 'DETPARPRE_01', name: 'Enero' }, { codigo: 'DETPARPRE_02', name: 'Febrero' },
      { codigo: 'DETPARPRE_03', name: 'Marzo' }, { codigo: 'DETPARPRE_04', name: 'Abril' },
      { codigo: 'DETPARPRE_05', name: 'Mayo' }, { codigo: 'DETPARPRE_06', name: 'Junio' },
      { codigo: 'DETPARPRE_07', name: 'Julio' }, { codigo: 'DETPARPRE_08', name: 'Agosto' },
      { codigo: 'DETPARPRE_09', name: 'Septiembre' }, { codigo: 'DETPARPRE_10', name: 'Octubre' },
      { codigo: 'DETPARPRE_11', name: 'Noviembre' }, { codigo: 'DETPARPRE_12', name: 'Diciembre' },
      { codigo: 'DETPARPRE_TOTAL', name: 'Total' },
    ]

    await this.getPermisos();
  }
  async getPermisos() {
    try {
      const data = await this.permisosService.getPermisosFrm(this.init.tabs[this.init.tabindex - 1].component);
      if (data !== null) {
        if (data[0] !== undefined) {
          this.permisoParpre = data[0];
        } else {
          this.permisoParpre = null;
        }
      } else {
        this.permisoParpre = null;
      }
    } catch (e) {
      this.permisoParpre = null;
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Error',
        detail: 'No se pudo obtener los permisos del formulario'
      });
    }
  }

  manejarSenales(evento) {

    if (evento === 'Nuevo') {
      if (this.permisoParpre.PERTODO === 1) {
        this.nuevo();
      } else {
        if (this.permisoParpre.PERINSERCION === 1) {
          this.nuevo();
        } else {
          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de inserción, acción denegada.'
          });
        }
      }
    }
    if (evento === 'Cancelar') {
      this.cancelar();
    }
    if (evento === 'Excel') {
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'Ya no se puede editar una partida presupuestaria consolidada'
        });
        return;
      }
      let anio = this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO
      if (isNullOrUndefined(anio) || anio === '') {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'El año no puede estar vacío'
        });
        return;
      }
      this.inputfile.nativeElement.click();
      return;
    }
    if (evento === 'Guardar') {
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'Ya no se puede editar una partida presupuestaria consolidada'
        });
        return;
      }
      if (this.permisoParpre.PERTODO === 1) {
        this.spin = true;
        this.validaguardar();
      } else {
        if (this.permisoParpre.PERACTUALIZACION === 1) {
          this.spin = true;
          this.validaguardar();
        } else {
          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de actualización, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Borrar') {
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'No puede eliminar una partida presupuestaria en estado OK'
        });
        return;
      }
      if (this.index === 0) {
        if (this.permisoParpre.PERTODO === 1) {
          this.confirmarborrar();
        } else {
          if (this.permisoParpre.PERELIMACION === 1) {
            this.confirmarborrar();
          } else {
            this.messageService.add({
              key: 'presuparti',
              severity: 'error',
              summary: 'Información',
              detail: 'El usuario no tiene permisos de eliminación, acción denegada.'
            });
          }
        }
      }
    }
    if (evento === 'Buscar') {
      if (this.permisoParpre.PERTODO === 1) {
        this.busqueda()
      } else {
        if (this.permisoParpre.PERSELECCION === 1) {
          this.busqueda()
        } else {
          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'El usuario no tiene permisos de consulta, acción denegada.'
          });
        }
      }

    }
    if (evento === 'Autorizar') {

      this.autorizar();
    }
    if (evento === 'Descargar') {
      this.descargarDemo()
    }
    if (evento === 'Salir') {
      this.init.tabs.splice(this.init.tabindex, 1);
    }

  }
  autorizar() {
    try {
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'P') {
        this.confirmautoriza()
      }
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
        this.confirmreversaautoriza()
      }
    } catch (error) {

    }
  }
  async confirmautoriza() {
    this.confirmationService.confirm({
      message: 'Está seguro de autorizar la partida presupuestaria?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmpresuparti',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.claveAuth = '';
        this.actestado = 'O';
        this.mensajeestado = 'Debe ingresar la razón para autorizar la partida presupuestaria'
        this.displayDialogAutorizacion = true;

        //this.cambiarestado('O');
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  confirmreversaautoriza() {
    this.confirmationService.confirm({
      message: 'Está seguro de reversar la partida presupuestaria?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmpresuparti',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.claveAuth = '';
        this.actestado = 'P';
        this.mensajeestado = 'Debe ingresar la razón para reversar la partida presupuestaria'
        this.displayDialogAutorizacion = true;

        //this.cambiarestado('P');
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }

  comprobarClave() {
    this.conpartidapresuService.obtenerClave().subscribe((clave) => {
      let claveReal;
      claveReal = clave[0].AUTORIZACION_CLAVE;
      if (claveReal === this.claveAuth) {

        this.indicarrazon()
      } else if (clave !== this.claveAuth) {
        this.messageService.add({
          key: 'autorizacion',
          severity: 'error',
          summary: 'Clave Autorización',
          detail: 'La clave que se ingresó es incorrecta, intente nuevamente'
        });
      }
    });
  }
  indicarrazon() {
    this.displayDialogRazon = true;
    this.displayDialogAutorizacion = false;
    this.razonaut = '';
    //this.mensajeestado = 'Debe ingresar la razón para reversar la partida presupuestaria'
  }
  async autcambiaestado() {
    console.log(this.razonaut.length)
    if (this.razonaut.length === 0) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'warn',
        summary: 'Información',
        detail: 'Para cambiar el estado se debe ingresar la razón.'
      });
      return;
    }
    this.cambiarestado(this.actestado);
  }
  cancelarautcambiaestado() {
    this.displayDialogRazon = false;
    this.razonaut = ''
  }

  async cambiarestado(estado) {
    try {
      console.log(estado)
      if (isNullOrUndefined(estado) === false && estado !== '') {
        await this.conpartidapresuService.cambiarestadoparpre(this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO, estado)
        this.auditoriagral.registrarAuditoria('CON_ENCPARPRE', this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '/estado: ' + estado + '/razón:' + this.razonaut, 'A',
          '', '01', '', '', '', '').subscribe(() => { });
        this.messageService.add({
          key: 'presuparti',
          severity: 'success',
          summary: 'Partida Presupuestaria',
          detail: 'Éxito al ejecutar el proceso'
        });
        this.cancelar()
        this.displayDialogAutorizacion = false;
        this.displayDialogRazon = false;
        this.razonaut = ''
        this.claveAuth = '';
      }
    } catch (error) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al actualizar el estado de la partida presupuestaria'
      });
    }
  }
  onHideAutorizacion() {
    this.displayDialogAutorizacion = false;
    this.claveAuth = '';
    // this.actestado = '';
    // this.mensajeestado='';
  }
  async descargarDemo() {
    try {
      const rs: any = await this.uploadFileService.getDocument('PARTIDA_PRESUPUESTARIA_DEMO.xlsx');
      this.downloadDocument(rs.respuesta, 'PARTIDA_PRESUPUESTARIA_DEMO.xlsx');
    } catch (err) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrio un error al encontrar el archivo'
      });
    }
  }
  downloadDocument(strBase64, filename) {
    const byteCharacters = atob(strBase64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const data = window.URL.createObjectURL(blob);
    let link = document.createElement('a');
    link.href = data;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setTimeout(() => {
      window.URL.revokeObjectURL(data);
    }, 1000)
  }
  confirmarborrar() {
    //if (this.conpresuanucenService.encabezadoPresuAnuSeleccionadoarray[this.indicador].CONTROL !== 0) {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmpresuparti',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.eliminarregistro();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
    //}
  }
  async eliminarregistro() {
    try {
      await this.conpartidapresuService.eliminarregistro(this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO);
      this.messageService.add({
        key: 'presuparti',
        severity: 'success',
        summary: 'Eliminar Presupuesto',
        detail: 'Se eliminó con éxito el registro'
      });
      this.auditoriagral.registrarAuditoria('CON_ENCPARPRE', this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO, 'E',
        '', '01', '', '', '', '').subscribe(() => { });
      this.btnNuevo = false;
      this.btnGuardar = true;
      this.btnBorrar = false;
      this.btnRegresar = true;
      this.spin = false
      this.index = 0;
      this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador] = {};
      this.conpartidapresuService.detpartipresupuestoarray = [];
    } catch (error) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Eliminar Encabezado',
        detail: 'Ocurrió un error al elimnar el registro'
      });
      this.spin = false;
      return
    }
  }
  busqueda() {
    this.opcion = 'BUSQUEDA';
    this.types = [
      { label: 'Año', value: 'ENCPARPRE_ANIO' },
      { label: 'Descripcion', value: 'ENCPARPRE_COMENTARIO' },
      { label: 'Estado', value: 'ENCPARPRE_ESTADO' },
    ];
    this.busquedacampos = ['', '', ''];
    this.tabla = 'CON_ENCPARPRE';
    this.where = ''
    this.busquedaSer.busquedaPartidaPresu().subscribe((res: any[]) => {
      if (res !== null && res !== undefined) {
        this.arregloCons = res;
        this.displayDialogBusquedaFast = true;
      } else {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'INFORMACIÓN',
          detail: 'Aún no hay ninguna partida'
        });
        this.spin = false;
        return;
      }
    });
  }
  busquedanumero() {
    if (this.btnGuardar === false) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'INFORMACIÓN',
        detail: 'Por favor primero debe guardar la partida'
      });
      this.spin = false;
      return;
    }
    this.opcion = 'BUSQUEDADET';
    this.types = [
      { label: 'Número', value: 'DETPARPRE_NUMERO' },
      { label: 'Nombre', value: 'DETPARPRE_NOMBRE' }

    ];
    this.busquedacampos = ['', ''];
    this.tabla = 'CON_DETPARPRE';
    this.where = 'ENCPARPRE_ANIO=\'' + this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '\''

    this.busquedaSer.busquedadetPartidaPresu(this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO).subscribe((res: any[]) => {
      if (res !== null && res !== undefined) {
        this.arregloCons = res;
        this.displayDialogBusquedaFast = true;
      } else {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'INFORMACIÓN',
          detail: 'Aún no hay ninguna partida'
        });
        this.spin = false;
        return;
      }
    });
  }
  manejarSeleccion(opcion) {
    if (this.opcion === 'BUSQUEDA') {
      this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO = opcion.ENCPARPRE_ANIO;
      this.busquedaanio(opcion.ENCPARPRE_ANIO)
      this.displayDialogBusquedaFast = false;
    }
    if (this.opcion === 'BUSQUEDADET') {
      let i = 1
      this.conpartidapresuService.detpartipresupuestoarray = []

      this.conpartidapresuService.detpartipresupuestoarray.push(opcion)
      for (const item of this.conpartidapresuService.detpartipresupuestoarray) {
        item.DETPARPRE_01 = Number(item.DETPARPRE_01).toFixed(2)
        item.DETPARPRE_02 = Number(item.DETPARPRE_02).toFixed(2)
        item.DETPARPRE_03 = Number(item.DETPARPRE_03).toFixed(2)
        item.DETPARPRE_04 = Number(item.DETPARPRE_04).toFixed(2)
        item.DETPARPRE_05 = Number(item.DETPARPRE_05).toFixed(2)
        item.DETPARPRE_06 = Number(item.DETPARPRE_06).toFixed(2)
        item.DETPARPRE_07 = Number(item.DETPARPRE_07).toFixed(2)
        item.DETPARPRE_08 = Number(item.DETPARPRE_08).toFixed(2)
        item.DETPARPRE_09 = Number(item.DETPARPRE_09).toFixed(2)
        item.DETPARPRE_10 = Number(item.DETPARPRE_10).toFixed(2)
        item.DETPARPRE_11 = Number(item.DETPARPRE_11).toFixed(2)
        item.DETPARPRE_12 = Number(item.DETPARPRE_12).toFixed(2)
        item.DETPARPRE_TOTAL = Number(item.DETPARPRE_TOTAL).toFixed(2)
        item.DETPARPRE_LINEA = i;
        i++
        this.detpartipresuelect = item
      }
      this.aggrid.refreshaggrid(this.conpartidapresuService.detpartipresupuestoarray, this.defaultColDefPartiPresu.objeto);
      this.displayDialogBusquedaFast = false;
    }

  }
  async validaguardar() {
    try {
      let anio = this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO
      const anios = Array.from(new Set(this.conpartidapresuService.detpartipresupuestoarray.map(item => String(item.ENCPARPRE_ANIO))))
      if (this.conpartidapresuService.detpartipresupuestoarray.length === 0) {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'El detalle no puede estar vacío'
        });
        this.spin = false;
        return;
      }
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_COMENTARIO === '') {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'La descripción no puede estar vacía'
        });
        this.spin = false;
        return;
      }
      for (const iteranios of anios) {
        if (iteranios !== anio) {
          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'El año del encabezado debe ser igual a los años en el detalle vuelva a cargar la plantilla por favor'
          });
          this.spin = false;
          return;
        }
      }
      if (isNullOrUndefined(anio) || anio === '') {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'El año no puede estar vacío'
        });
        this.spin = false;
        return;
      }
      for (const iterator of this.conpartidapresuService.detpartipresupuestoarray) {
        if (isNullOrUndefined(iterator.DETPARPRE_NUMERO) || iterator.DETPARPRE_NUMERO === '') {
          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'El campo número no puede estar vacío'
          });
          this.spin = false;
          return
        }
        if (await this.trnasfornumero(iterator.DETPARPRE_01) < 0 || await this.trnasfornumero(iterator.DETPARPRE_02) < 0 || await this.trnasfornumero(iterator.DETPARPRE_03) < 0
          || await this.trnasfornumero(iterator.DETPARPRE_04) < 0 || await this.trnasfornumero(iterator.DETPARPRE_05) < 0 || await this.trnasfornumero(iterator.DETPARPRE_06) < 0
          || await this.trnasfornumero(iterator.DETPARPRE_07) < 0 || await this.trnasfornumero(iterator.DETPARPRE_08) < 0 || await this.trnasfornumero(iterator.DETPARPRE_09) < 0
          || await this.trnasfornumero(iterator.DETPARPRE_10) < 0 || await this.trnasfornumero(iterator.DETPARPRE_11) < 0 || await this.trnasfornumero(iterator.DETPARPRE_12) < 0
          || await this.trnasfornumero(iterator.DETPARPRE_TOTAL) < 0
        ) {

          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'No pueden haber valores menores a cero'
          });
          this.spin = false;
          return
        }
        if (isNullOrUndefined(iterator.DETPARPRE_01) || isNullOrUndefined(iterator.DETPARPRE_02) || isNullOrUndefined(iterator.DETPARPRE_03)
          || isNullOrUndefined(iterator.DETPARPRE_04) || isNullOrUndefined(iterator.DETPARPRE_05) || isNullOrUndefined(iterator.DETPARPRE_06)
          || isNullOrUndefined(iterator.DETPARPRE_07) || isNullOrUndefined(iterator.DETPARPRE_08) || isNullOrUndefined(iterator.DETPARPRE_09)
          || isNullOrUndefined(iterator.DETPARPRE_10) || isNullOrUndefined(iterator.DETPARPRE_11) || isNullOrUndefined(iterator.DETPARPRE_12)
          || isNullOrUndefined(iterator.DETPARPRE_TOTAL)
          || iterator.DETPARPRE_01 === '' || iterator.DETPARPRE_02 === '' || iterator.DETPARPRE_03 === ''
          || iterator.DETPARPRE_04 === '' || iterator.DETPARPRE_05 === '' || iterator.DETPARPRE_06 === ''
          || iterator.DETPARPRE_07 === '' || iterator.DETPARPRE_08 === '' || iterator.DETPARPRE_09 === ''
          || iterator.DETPARPRE_10 === '' || iterator.DETPARPRE_11 === '' || iterator.DETPARPRE_12 === ''
          || iterator.DETPARPRE_TOTAL === ''
        ) {

          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'No pueden haber valores en blanco'
          });
          this.spin = false;
          return
        }
      }
      await this.guardar();
    } catch (error) {
      {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'Hubo un error al validar antes de guardar'
        });
        console.log(error)
        this.spin = false;
        return
      }
    }
  }
  async guardar() {
    try {
      if (this.boolnuevo) {
        await this.conpartidapresuService.insertaencparpre(this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador])
        await this.auditoriagral.registrarAuditoria('CON_ENCPARPRE',
          this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '/' + this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_COMENTARIO, 'I',
          '', '01', '', '', '', '').toPromise();
        for (const iterator of this.conpartidapresuService.detpartipresupuestoarray) {
          if (iterator.DETPARPRE_LINEA === 0) {
            await this.conpartidapresuService.insertadetparpre(iterator)
            for (const data of this.etiquetasaudi) {
              if (data.name !== '') {
                await this.auditoriagral.registrarAuditoria('CON_DETPARPRE',
                  this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '/' + iterator.DETPARPRE_NUMERO + '/' + data.name + ':' + iterator[data.codigo], 'I',
                  '', '01', '', '', '', '').toPromise();
              }
            }


          } else {
            await this.conpartidapresuService.actualizadetparpre(iterator)
            for (const data of this.etiquetasaudi) {
              if (data.name !== '') {
                await this.auditoriagral.registrarAuditoria('CON_DETPARPRE',
                  this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '/' + iterator.DETPARPRE_NUMERO + '/' + data.name + ':' + iterator[data.codigo], 'A',
                  '', '01', '', '', '', '').toPromise();
              }
            }
          }
        }
        this.messageService.add({
          key: 'presuparti',
          severity: 'success',
          summary: 'Información',
          detail: 'Partida guardada con éxito'
        });
        this.btnNuevo = false;
        this.btnGuardar = true;
        this.btnBorrar = false;
        this.btnRegresar = true;
        this.spin = false;
        await this.cancelar();
      } else {
        await this.conpartidapresuService.actualizaencparpre(this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador])
        await this.auditoriagral.registrarAuditoria('CON_ENCPARPRE',
          this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '/' + this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_COMENTARIO, 'A',
          '', '01', '', '', '', '').toPromise();
        for (const iterator of this.conpartidapresuService.detpartipresupuestoarray) {
          if (iterator.DETPARPRE_LINEA === 0) {
            await this.conpartidapresuService.insertadetparpre(iterator)
            for (const data of this.etiquetasaudi) {
              if (data.name !== '') {
                await this.auditoriagral.registrarAuditoria('CON_DETPARPRE',
                  this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '/' + iterator.DETPARPRE_NUMERO + '/' + data.name + ':' + iterator[data.codigo], 'I',
                  '', '01', '', '', '', '').toPromise();
              }
            }
          } else {
            await this.conpartidapresuService.actualizadetparpre(iterator)
            for (const data of this.etiquetasaudi) {
              if (data.name !== '') {
                await this.auditoriagral.registrarAuditoria('CON_DETPARPRE',
                  this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO + '/' + iterator.DETPARPRE_NUMERO + '/' + data.name + ':' + iterator[data.codigo], 'A',
                  '', '01', '', '', '', '').toPromise();
              }
            }
          }
        }
        this.messageService.add({
          key: 'presuparti',
          severity: 'success',
          summary: 'Información',
          detail: 'Partida actualizada con éxito'
        });
        this.btnNuevo = false;
        this.btnGuardar = true;
        this.btnBorrar = false;
        this.btnRegresar = true;
        this.spin = false;
        await this.cancelar();
      }

    } catch (error) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al guardar la información'
      });
      this.spin = false;
      console.log(error)
    }
  }
  async onBasicUpload(ev) {
    let validacionVacio = true;
    console.log(ev[0]);
    console.log(ev);
    let workBook = null;
    let jsonData = null;
    const reader = new FileReader();
    const file = ev[0];
    reader.onload = async (event) => {
      const data = reader.result;
      workBook = XLSX.read(data, { type: 'binary', cellDates: true, cellNF: false, cellText: false });

      jsonData = workBook.SheetNames.reduce((initial, name) => {
        console.log(workBook.Sheets[name]);
        const sheet = workBook.Sheets[name];
        initial[name] = XLSX.utils.sheet_to_json(sheet, { defval: '' });
        return initial;
      }, {});
      console.log(jsonData.Hoja1);

      for (let data of jsonData.Hoja1) {

        delete data.__EMPTY;
        for (let key in data) { // se revisa los campos del json generado del excel,
          // si uno de esos campos no existe o está vacío no se activará el boton de guardar
          if (data[key] === '') {
            validacionVacio = false;
          }

        }
      }
      this.datosJson = jsonData.Hoja1;
      console.log(this.datosJson)
      this.inputfile.nativeElement.value = ''

      await this.validaexcell();

    }
    reader.readAsBinaryString(file);
  }
  async validaexcell() {
    try {
      this.spin = true
      let anio = this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO
      const conteonum = this.datosJson.map(item => (item.NUMERO))
        .reduce((acc, numero) => {
          acc[numero] = (acc[numero] || 0) + 1;
          return acc
        }, {});
      const reducenum = Object.entries(conteonum).map(([numero, cantidad]) => ({
        numero,
        cantidad
      }));
      if (this.conpartidapresuService.detpartipresupuestoarray.length > 0) {
        const numero = Array.from(new Set(this.datosJson.map(item => String(item.NUMERO))))
        for (const iterator of this.conpartidapresuService.detpartipresupuestoarray) {
          for (const item of numero) {
            if (iterator.DETPARPRE_NUMERO === item) {
              this.messageService.add({
                key: 'presuparti',
                severity: 'error',
                summary: 'Información',
                detail: 'El número ' + iterator.DETPARPRE_NUMERO + ', ya está registrado en el detalle'
              });
              this.spin = false;
              return
            }
          }
        }
      }
      for (const iterator of reducenum) {
        if (iterator.cantidad > 1) {
          this.messageService.add({
            key: 'presuparti',
            severity: 'error',
            summary: 'Información',
            detail: 'El número ' + iterator.numero + ', está repetido'
          });
          this.spin = false;
          return
        }
      }

      if (this.datosJson.length > 0) {
        for (const iterator of this.datosJson) {
          if (isNullOrUndefined(iterator.NUMERO) || iterator.NUMERO === '') {
            this.messageService.add({
              key: 'presuparti',
              severity: 'error',
              summary: 'Información',
              detail: 'El campo número no puede estar vacío'
            });
            this.spin = false;
            return
          }

          if (await this.trnasfornumero(iterator.ENERO) < 0 || await this.trnasfornumero(iterator.FEBRERO) < 0 || await this.trnasfornumero(iterator.MARZO) < 0
            || await this.trnasfornumero(iterator.ABRIL) < 0 || await this.trnasfornumero(iterator.MAYO) < 0 || await this.trnasfornumero(iterator.JUNIO) < 0
            || await this.trnasfornumero(iterator.JULIO) < 0 || await this.trnasfornumero(iterator.AGOSTO) < 0 || await this.trnasfornumero(iterator.SEPTIEMBRE) < 0
            || await this.trnasfornumero(iterator.OCTUBRE) < 0 || await this.trnasfornumero(iterator.NOVIEMBRE) < 0 || await this.trnasfornumero(iterator.DICIEMBRE) < 0
            || await this.trnasfornumero(iterator.TOTAL) < 0
          ) {
            this.messageService.add({
              key: 'presuparti',
              severity: 'error',
              summary: 'Información',
              detail: 'No pueden haber valores menores a cero'
            });
            this.spin = false;
            return
          }
          let reg: Presupartidet = {}
          reg.ENCPARPRE_ANIO = anio,
            reg.DETPARPRE_NUMERO = iterator.NUMERO.toString().substring(0, 30);
          reg.DETPARPRE_NOMBRE = iterator.NOMBRE.toString().substring(0, 50);
          reg.DETPARPRE_01 = Number(isNullOrUndefined(iterator.ENERO) || iterator.ENERO === '' ? 0 : iterator.ENERO).toFixed(2)
          reg.DETPARPRE_02 = Number(isNullOrUndefined(iterator.FEBRERO) || iterator.FEBRERO === '' ? 0 : iterator.FEBRERO).toFixed(2)
          reg.DETPARPRE_03 = Number(isNullOrUndefined(iterator.MARZO) || iterator.MARZO === '' ? 0 : iterator.MARZO).toFixed(2)
          reg.DETPARPRE_04 = Number(isNullOrUndefined(iterator.ABRIL) || iterator.ABRIL === '' ? 0 : iterator.ABRIL).toFixed(2)
          reg.DETPARPRE_05 = Number(isNullOrUndefined(iterator.MAYO) || iterator.MAYO === '' ? 0 : iterator.MAYO).toFixed(2)
          reg.DETPARPRE_06 = Number(isNullOrUndefined(iterator.JUNIO) || iterator.JUNIO === '' ? 0 : iterator.JUNIO).toFixed(2)
          reg.DETPARPRE_07 = Number(isNullOrUndefined(iterator.JULIO) || iterator.JULIO === '' ? 0 : iterator.JULIO).toFixed(2)
          reg.DETPARPRE_08 = Number(isNullOrUndefined(iterator.AGOSTO) || iterator.AGOSTO === '' ? 0 : iterator.AGOSTO).toFixed(2)
          reg.DETPARPRE_09 = Number(isNullOrUndefined(iterator.SEPTIEMBRE) || iterator.SEPTIEMBRE === '' ? 0 : iterator.SEPTIEMBRE).toFixed(2)
          reg.DETPARPRE_10 = Number(isNullOrUndefined(iterator.OCTUBRE) || iterator.OCTUBRE === '' ? 0 : iterator.OCTUBRE).toFixed(2)
          reg.DETPARPRE_11 = Number(isNullOrUndefined(iterator.NOVIEMBRE) || iterator.NOVIEMBRE === '' ? 0 : iterator.NOVIEMBRE).toFixed(2)
          reg.DETPARPRE_12 = Number(isNullOrUndefined(iterator.DICIEMBRE) || iterator.DICIEMBRE === '' ? 0 : iterator.DICIEMBRE).toFixed(2)
          reg.DETPARPRE_TOTAL = Number(isNullOrUndefined(iterator.TOTAL) || iterator.TOTAL === '' ? 0 : iterator.TOTAL).toFixed(2)
          reg.DETPARPRE_LINEA = 0
          this.conpartidapresuService.detpartipresupuestoarray.push(reg)
          this.detpartipresuelect = reg
        }
      }
      this.aggrid.refreshaggrid(this.conpartidapresuService.detpartipresupuestoarray, this.defaultColDefPartiPresu.objeto);
      this.spin = false
      this.cambio(true)
    } catch (error) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cargar los datos del Excel'
      });
      this.spin = false;
      console.log(error)
    }
  }
  async trnasfornumero(numero) {
    try {
      let numtransform = 0
      numtransform = isNullOrUndefined(numero) || numero === '' ? 0 : numero;
      return numtransform
    } catch (error) {
      return 0
    }
  }
  async cancelar() {
    try {
      let anio = this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO
      if (isNullOrUndefined(anio) || anio === '') {
        this.btnNuevo = false;
        this.btnGuardar = true;
        this.btnBorrar = false;
        this.btnRegresar = true;
        this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador] = {};
        this.conpartidapresuService.detpartipresupuestoarray = [];
        this.detpartipresuelect = {}
        this.boolnuevo = true;
      } else {
        this.btnNuevo = false;
        this.btnGuardar = true;
        this.btnBorrar = false;
        this.btnRegresar = true;
        this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador] = {};
        this.conpartidapresuService.detpartipresupuestoarray = [];
        this.detpartipresuelect = {}
        await this.busquedaanio(anio)
      }

    } catch (error) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un error al cargar de nuevo la información'
      });
    }
  }
  async nuevo() {
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;
    this.boolnuevo = true;
    this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador] = {};
    this.conpartidapresuService.detpartipresupuestoarray = [];
    this.detpartipresuelect = {}
    const dato: Presupartienc = {
      ENCPARPRE_ANIO: '',
      ENCPARPRE_COMENTARIO: '',
      COM_CODIGO: '01',
      ENCPARPRE_ESTADO: 'P'
    }
    this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador] = dato
    this.lblestado = 'PENDIENTE'
    document.getElementById('ENCPARPRE_ANIO').focus();
  }
  cambioTab() {

  }

  setFocus(event) {
    switch (event.target.id) {
      case 'ENCPARPRE_ANIO': {
        document.getElementById('ENCPARPRE_COMENTARIO').focus();
        break;
      }
      default: {
        break;
      }
    }
  }
  async busquedaanio(encanio) {
    try {
      const data = await this.conpartidapresuService.getencparpre(encanio)
      if (isNullOrUndefined(data) === false) {

        for (const iterator of data) {

          if (isNullOrUndefined(iterator.ENCPARPRE_ANIO) === false) {
            this.boolnuevo = false
            this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador] = iterator
            if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
              this.lblestado = 'OK'

            } else if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'P') {
              this.lblestado = 'PENDIENTE'
            }
            const data2 = await this.conpartidapresuService.getdetparpre(iterator.ENCPARPRE_ANIO)
            if (isNullOrUndefined(data2) === false) {
              let i = 1
              for (const item of data2) {
                item.DETPARPRE_LINEA = i;
                item.DETPARPRE_01 = Number(item.DETPARPRE_01).toFixed(2)
                item.DETPARPRE_02 = Number(item.DETPARPRE_02).toFixed(2)
                item.DETPARPRE_03 = Number(item.DETPARPRE_03).toFixed(2)
                item.DETPARPRE_04 = Number(item.DETPARPRE_04).toFixed(2)
                item.DETPARPRE_05 = Number(item.DETPARPRE_05).toFixed(2)
                item.DETPARPRE_06 = Number(item.DETPARPRE_06).toFixed(2)
                item.DETPARPRE_07 = Number(item.DETPARPRE_07).toFixed(2)
                item.DETPARPRE_08 = Number(item.DETPARPRE_08).toFixed(2)
                item.DETPARPRE_09 = Number(item.DETPARPRE_09).toFixed(2)
                item.DETPARPRE_10 = Number(item.DETPARPRE_10).toFixed(2)
                item.DETPARPRE_11 = Number(item.DETPARPRE_11).toFixed(2)
                item.DETPARPRE_12 = Number(item.DETPARPRE_12).toFixed(2)
                item.DETPARPRE_TOTAL = Number(item.DETPARPRE_TOTAL).toFixed(2)
                i++;
                this.detpartipresuelect = item
              }
              this.conpartidapresuService.detpartipresupuestoarray = data2

            } else {
              this.conpartidapresuService.detpartipresupuestoarray = []
              this.detpartipresuelect = {}
            }
          } else {
            this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_COMENTARIO = '';
            this.conpartidapresuService.detpartipresupuestoarray = []
            this.boolnuevo = true
            this.detpartipresuelect = {}
          }

        }

      }
      document.getElementById('ENCPARPRE_COMENTARIO').focus();
    } catch (error) {

    }
  }
  selectedPartiPresu(params) {
    let anio = this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO

    if (params === 'nuevo') {
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
        return;
      }
      if (isNullOrUndefined(anio) || anio === '') {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un año'
        });
        return
      }
      this.nuevodetalle();
      return;
    }
    if (params === 'eliminar') {
      if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
        return;
      }
      if (isNullOrUndefined(this.detpartipresuelect)) {
        this.messageService.add({
          key: 'presuparti',
          severity: 'error',
          summary: 'Información',
          detail: 'Debe seleccionar un registro del detalle'
        });
        return
      }
      this.confirmaeliminadet();
    }
    if (params.object !== undefined) {
      this.detpartipresuelect = params.object;
    }

  }
  nuevodetalle() {
    try {
      let anio = this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO

      let detparpre: Presupartidet = {
        ENCPARPRE_ANIO: anio,
        COM_CODIGO: '01',
        DETPARPRE_NUMERO: '',
        DETPARPRE_01: Number(0).toFixed(2),
        DETPARPRE_02: Number(0).toFixed(2),
        DETPARPRE_03: Number(0).toFixed(2),
        DETPARPRE_04: Number(0).toFixed(2),
        DETPARPRE_05: Number(0).toFixed(2),
        DETPARPRE_06: Number(0).toFixed(2),
        DETPARPRE_07: Number(0).toFixed(2),
        DETPARPRE_08: Number(0).toFixed(2),
        DETPARPRE_09: Number(0).toFixed(2),
        DETPARPRE_10: Number(0).toFixed(2),
        DETPARPRE_11: Number(0).toFixed(2),
        DETPARPRE_12: Number(0).toFixed(2),
        DETPARPRE_TOTAL: Number(0).toFixed(2),
        DETPARPRE_NOMBRE: '',
        DETPARPRE_LINEA: 0

      }
      const indi = this.conpartidapresuService.detpartipresupuestoarray.indexOf(this.detpartipresuelect);
      if (indi === -1) {
        this.conpartidapresuService.detpartipresupuestoarray.push(detparpre);
        this.detpartipresuelect = detparpre;
        this.aggrid.refreshaggrid(this.conpartidapresuService.detpartipresupuestoarray, this.defaultColDefPartiPresu.objeto);

        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefPartiPresu.objeto].setFocusedCell(
          this.conpartidapresuService.detpartipresupuestoarray.length - 1, 'DETPARPRE_NUMERO');
      } else {
        this.conpartidapresuService.detpartipresupuestoarray.splice(indi + 1, 0, detparpre);
        this.detpartipresuelect = detparpre;
        this.aggrid.refreshaggrid(this.conpartidapresuService.detpartipresupuestoarray, this.defaultColDefPartiPresu.objeto);
        this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefPartiPresu.objeto].setFocusedCell(
          this.conpartidapresuService.detpartipresupuestoarray.length - 1, 'DETPARPRE_NUMERO');
      }
    } catch (error) {

    }
  }
  confirmaeliminadet() {
    this.confirmationService.confirm({
      message: 'Está seguro de eliminar el registro?',
      header: 'Pregunta',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmpresuparti',
      acceptLabel: 'Si',
      rejectLabel: 'No',
      accept: () => {
        this.eliminarregistrodet();
      },
      reject: () => {
        this.confirmationService.close();
      }
    });
  }
  async eliminarregistrodet() {
    try {
      if (this.detpartipresuelect.DETPARPRE_LINEA === 0) {     
        this.conpartidapresuService.detpartipresupuestoarray = this.conpartidapresuService.detpartipresupuestoarray.filter((val, j) => j !==
          this.conpartidapresuService.detpartipresupuestoarray.indexOf(this.detpartipresuelect));
          this.aggrid.refreshaggrid(this.conpartidapresuService.detpartipresupuestoarray, this.defaultColDefPartiPresu.objeto);
          this.messageService.add({
            key: 'presuparti',
            severity: 'success',
            summary: 'Insertar diario',
            detail: 'Se eliminó con éxito el registro'
          });
          
      } else {
        let numero = this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ANIO
        await this.conpartidapresuService.eliminarregistrodet(this.detpartipresuelect);
        this.auditoriagral.registrarAuditoria('CON_DETDIAPARPRE',
          numero + '/' + this.detpartipresuelect.DETPARPRE_NUMERO, 'E', '', '01', '', '', '', '').subscribe();
        this.aggrid.refreshaggrid(this.conpartidapresuService.detpartipresupuestoarray, this.defaultColDefPartiPresu.objeto);
        this.messageService.add({
          key: 'presuparti',
          severity: 'success',
          summary: 'Insertar diario',
          detail: 'Se eliminó con éxito el registro'
        });
      }
    } catch (error) {
      this.messageService.add({
        key: 'presuparti',
        severity: 'error',
        summary: 'Información',
        detail: 'Ocurrió un problema al elimnar la línea'
      });
      return
    }
  }
  cambio(evento) {
    if (this.conpartidapresuService.encabezadoPartipresuSelectarray[this.indicador].ENCPARPRE_ESTADO === 'O') {
      return;
    }
    this.btnNuevo = true;
    this.btnGuardar = false;
    this.btnBorrar = true;

  }
}
